import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard, Activity, ClipboardList, MapPin, Compass, Bot, Building2
} from 'lucide-react';

/* Mobile-only bottom tab navigation — 5 primary tabs max */
const MOBILE_TABS = {
  admin: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard' },
    { icon: Activity, label: 'Activities', path: '/activities' },
    { icon: ClipboardList, label: 'Tasks', path: '/tasks' },
    { icon: MapPin, label: 'Tracking', path: '/live-tracking' },
    { icon: Building2, label: 'Customers', path: '/customers' },
  ],
  owner: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard' },
    { icon: Activity, label: 'Activities', path: '/activities' },
    { icon: ClipboardList, label: 'Tasks', path: '/tasks' },
    { icon: MapPin, label: 'Tracking', path: '/live-tracking' },
    { icon: Building2, label: 'Customers', path: '/customers' },
  ],
  manager: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard' },
    { icon: Activity, label: 'Activities', path: '/activities' },
    { icon: ClipboardList, label: 'Tasks', path: '/tasks' },
    { icon: MapPin, label: 'Tracking', path: '/live-tracking' },
    { icon: Building2, label: 'Customers', path: '/customers' },
  ],
  salesperson: [
    { icon: LayoutDashboard, label: 'Home', path: '/dashboard' },
    { icon: Activity, label: 'Activities', path: '/activities' },
    { icon: ClipboardList, label: 'My Tasks', path: '/my-tasks' },
    { icon: Compass, label: 'Optimizer', path: '/visit-optimizer' },
    { icon: Bot, label: 'AI', path: '/ai-assistant' },
  ],
};

export function MobileBottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [lastScroll, setLastScroll] = useState(0);

  const role = user?.role || 'salesperson';
  const tabs = MOBILE_TABS[role] || MOBILE_TABS.salesperson;

  // Hide on scroll down, show on scroll up
  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setVisible(y < lastScroll || y < 100);
      setLastScroll(y);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScroll]);

  // Hide on landing/login pages
  const hiddenPaths = ['/', '/login', '/register', '/pricing'];
  if (hiddenPaths.includes(location.pathname)) return null;

  return (
    <nav
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 transition-transform duration-300 ${visible ? 'translate-y-0' : 'translate-y-full'}`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-14">
        {tabs.map(tab => {
          const isActive = location.pathname === tab.path ||
            (tab.path === '/dashboard' && location.pathname === '/dashboard');
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              className="flex flex-col items-center justify-center flex-1 h-full relative"
              data-testid={`mobile-tab-${tab.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#002FA7] rounded-b-full" />
              )}
              <tab.icon className={`w-5 h-5 ${isActive ? 'text-[#002FA7]' : 'text-gray-400'}`} />
              <span className={`text-[10px] mt-0.5 ${isActive ? 'text-[#002FA7] font-semibold' : 'text-gray-400'}`}>
                {tab.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
